import { render, staticRenderFns } from "./QueriesListNew.vue?vue&type=template&id=7e1448cf"
import script from "./QueriesListNew.vue?vue&type=script&lang=js"
export * from "./QueriesListNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports